import React, { memo } from "react";
import ReadonlyField from "./ReadonlyField";
import { COLORS, FIELD_COLORS, RESIDENTIAL_TYPES } from "../constants";

interface OtherDetailsProps {
  data?: any;
}

const OtherDetailsView: React.FC<OtherDetailsProps> = ({ data }) => {
  const isValidArray = data?.relatedPartyInformation
    ? Array.isArray(data?.relatedPartyInformation) &&
      data?.relatedPartyInformation.length > 0
    : false;
  const residentialType =
    RESIDENTIAL_TYPES.find((item) => item.code === data?.residentialType)
      ?.name ?? "";
  return (
    <div className="container mt-4">
      <div className="row">
        <ReadonlyField
          label="Type of Accomodation"
          value={data?.accommodationType || ""}
        />
        <ReadonlyField label="Residential type" value={residentialType} />
        <ReadonlyField label="City" value={data?.city || ""} />
        <ReadonlyField
          label="Are you the breadwinner of the family?"
          value={data?.isBreadWinner ? "Yes" : "No"}
        />

        <ReadonlyField
          label="Are you Responsible for making  payments"
          value={data?.customerResponsibleForPayment ? "Yes" : "No"}
        />
        {/* <ReadonlyField label="Person Responsible For Payments" value="Yes" /> */}
        <ReadonlyField
          label="Are you using RDEF?"
          value={data?.isRedf ? "Yes" : "No"}
        />
        <ReadonlyField
          label="Are you a Quara Finance Employee?"
          value={data?.quaraFinanceEmployee ? "Yes" : "No"}
        />

        <ReadonlyField
          label="Are you Political Person?"
          value={data?.politicalPerson ? "Yes" : "No"}
        />
        <ReadonlyField
          label="Do you have Relatives in Quara Finance?"
          value={data?.isRelative ? "Yes" : "No"}
        />
      </div>
      <p className="text-dark fs-5 m-0" style={{ color: COLORS.TEXT_PRIMARY }}>
        Related Party Information
      </p>
      <div
        className="mt-2"
        style={{
          background: FIELD_COLORS.defaultValueBgColor,
          borderRadius: 10,
          padding: "10px 16px",
          color: FIELD_COLORS.defaultValueColor,
          alignItems: "center",
          fontWeight: "600",
        }}
      >
        {isValidArray ? (
          data?.relatedPartyInformation.map((item, index) => (
            <div key={index}>
              {index + 1}. {item?.name ?? "-"}
            </div>
          ))
        ) : (
          <label>No Information Available</label>
        )}
      </div>
    </div>
  );
};

export default memo(OtherDetailsView);
